import http from '../../../http/base';
import { API_PATHS } from '../../../http/configs';

export function transferMembers(facilityID, memberDatas) {
    return http.post(`${API_PATHS.memberTransfer}/${facilityID}`, memberDatas);
}